const GradientLine = {
    id: 'GradientLine',
    afterDraw(chart) {
        const [dataset] = chart.config.data.datasets;

        if (typeof dataset !== 'undefined') {
            const minValue = chart.options.linearGradientThreshold;
            const maxValue = chart.options.linearGradientMax;
            const yAxis = chart.scales.y;
            const minValueYPixel = yAxis.getPixelForValue(minValue);
            const maxValueYPixel = yAxis.getPixelForValue(maxValue);
            const { ctx } = chart;
            const gradient = ctx.createLinearGradient(0, minValueYPixel, 0, maxValueYPixel + 0.001);
            // added 0.001 for the if minValuePixel is equal to  maxValueYPixel then gradient is not applied

            if (minValueYPixel <= maxValueYPixel) {
                gradient.addColorStop(0, '#3777BC');
                gradient.addColorStop(1, '#3777BC');
            } else {
                gradient.addColorStop(0, '#3777BC');
                gradient.addColorStop(0.1, '#B75376');
                gradient.addColorStop(0.5, '#B75376');
                gradient.addColorStop(1, '#B75376');
            }
            dataset.borderColor = gradient;
            dataset.pointStrokeColor = gradient;
            dataset.pointHighlightStroke = gradient;
            chart.update();
        }
    }
};

export default GradientLine;
